/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { ApiMasseSalariale } from "../model"
// @ts-ignore
import type { MasseSalarialeFonctionInput } from "../model"
// @ts-ignore
import type { SaveMasseSalarialeRequest } from "../model"
/**
 * MasseSalarialeResourceV2Api - axios parameter creator
 */
export const MasseSalarialeResourceV2ApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Delete salary mass
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMasseSalariale: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("deleteMasseSalariale", "noteId", noteId)
      const localVarPath = `/v2.0/masseSalariale/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete salary mass function by id
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMasseSalarialeFonction: async (
      id: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("deleteMasseSalarialeFonction", "id", id)
      const localVarPath = `/v2.0/masseSalariale/masseSalarialeFonction/{id}`.replace(
        "{id}",
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get salary mass
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMasseSalariale: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getMasseSalariale", "noteId", noteId)
      const localVarPath = `/v2.0/masseSalariale/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Create or update salary mass function by noteId and id
     * @param {string} noteId
     * @param {MasseSalarialeFonctionInput} masseSalarialeFonctionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveMasseSalarialeFonction: async (
      noteId: string,
      masseSalarialeFonctionInput: MasseSalarialeFonctionInput,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("saveMasseSalarialeFonction", "noteId", noteId)
      // verify required parameter 'masseSalarialeFonctionInput' is not null or undefined
      assertParamExists(
        "saveMasseSalarialeFonction",
        "masseSalarialeFonctionInput",
        masseSalarialeFonctionInput
      )
      const localVarPath = `/v2.0/masseSalariale/{noteId}/masseSalarialeFonction`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        masseSalarialeFonctionInput,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Create or update salary mass
     * @param {SaveMasseSalarialeRequest} saveMasseSalarialeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMasseSalariale: async (
      saveMasseSalarialeRequest: SaveMasseSalarialeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saveMasseSalarialeRequest' is not null or undefined
      assertParamExists(
        "updateMasseSalariale",
        "saveMasseSalarialeRequest",
        saveMasseSalarialeRequest
      )
      const localVarPath = `/v2.0/masseSalariale`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saveMasseSalarialeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MasseSalarialeResourceV2Api - functional programming interface
 */
export const MasseSalarialeResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MasseSalarialeResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete salary mass
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMasseSalariale(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMasseSalariale(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MasseSalarialeResourceV2Api.deleteMasseSalariale"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete salary mass function by id
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMasseSalarialeFonction(
      id: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMasseSalarialeFonction(
        id,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MasseSalarialeResourceV2Api.deleteMasseSalarialeFonction"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get salary mass
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMasseSalariale(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMasseSalariale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMasseSalariale(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MasseSalarialeResourceV2Api.getMasseSalariale"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create or update salary mass function by noteId and id
     * @param {string} noteId
     * @param {MasseSalarialeFonctionInput} masseSalarialeFonctionInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveMasseSalarialeFonction(
      noteId: string,
      masseSalarialeFonctionInput: MasseSalarialeFonctionInput,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMasseSalariale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveMasseSalarialeFonction(
        noteId,
        masseSalarialeFonctionInput,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MasseSalarialeResourceV2Api.saveMasseSalarialeFonction"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create or update salary mass
     * @param {SaveMasseSalarialeRequest} saveMasseSalarialeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMasseSalariale(
      saveMasseSalarialeRequest: SaveMasseSalarialeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMasseSalariale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateMasseSalariale(
        saveMasseSalarialeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MasseSalarialeResourceV2Api.updateMasseSalariale"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * MasseSalarialeResourceV2Api - factory interface
 */
export const MasseSalarialeResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MasseSalarialeResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Delete salary mass
     * @param {MasseSalarialeResourceV2ApiDeleteMasseSalarialeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMasseSalariale(
      requestParameters: MasseSalarialeResourceV2ApiDeleteMasseSalarialeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteMasseSalariale(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete salary mass function by id
     * @param {MasseSalarialeResourceV2ApiDeleteMasseSalarialeFonctionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMasseSalarialeFonction(
      requestParameters: MasseSalarialeResourceV2ApiDeleteMasseSalarialeFonctionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteMasseSalarialeFonction(requestParameters.id, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get salary mass
     * @param {MasseSalarialeResourceV2ApiGetMasseSalarialeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMasseSalariale(
      requestParameters: MasseSalarialeResourceV2ApiGetMasseSalarialeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiMasseSalariale> {
      return localVarFp
        .getMasseSalariale(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Create or update salary mass function by noteId and id
     * @param {MasseSalarialeResourceV2ApiSaveMasseSalarialeFonctionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveMasseSalarialeFonction(
      requestParameters: MasseSalarialeResourceV2ApiSaveMasseSalarialeFonctionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiMasseSalariale> {
      return localVarFp
        .saveMasseSalarialeFonction(
          requestParameters.noteId,
          requestParameters.masseSalarialeFonctionInput,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Create or update salary mass
     * @param {MasseSalarialeResourceV2ApiUpdateMasseSalarialeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMasseSalariale(
      requestParameters: MasseSalarialeResourceV2ApiUpdateMasseSalarialeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiMasseSalariale> {
      return localVarFp
        .updateMasseSalariale(requestParameters.saveMasseSalarialeRequest, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for deleteMasseSalariale operation in MasseSalarialeResourceV2Api.
 */
export interface MasseSalarialeResourceV2ApiDeleteMasseSalarialeRequest {
  readonly noteId: string
}

/**
 * Request parameters for deleteMasseSalarialeFonction operation in MasseSalarialeResourceV2Api.
 */
export interface MasseSalarialeResourceV2ApiDeleteMasseSalarialeFonctionRequest {
  readonly id: number
}

/**
 * Request parameters for getMasseSalariale operation in MasseSalarialeResourceV2Api.
 */
export interface MasseSalarialeResourceV2ApiGetMasseSalarialeRequest {
  readonly noteId: string
}

/**
 * Request parameters for saveMasseSalarialeFonction operation in MasseSalarialeResourceV2Api.
 */
export interface MasseSalarialeResourceV2ApiSaveMasseSalarialeFonctionRequest {
  readonly noteId: string

  readonly masseSalarialeFonctionInput: MasseSalarialeFonctionInput
}

/**
 * Request parameters for updateMasseSalariale operation in MasseSalarialeResourceV2Api.
 */
export interface MasseSalarialeResourceV2ApiUpdateMasseSalarialeRequest {
  readonly saveMasseSalarialeRequest: SaveMasseSalarialeRequest
}

/**
 * MasseSalarialeResourceV2Api - object-oriented interface
 */
export class MasseSalarialeResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Delete salary mass
   * @param {MasseSalarialeResourceV2ApiDeleteMasseSalarialeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteMasseSalariale(
    requestParameters: MasseSalarialeResourceV2ApiDeleteMasseSalarialeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MasseSalarialeResourceV2ApiFp(this.configuration)
      .deleteMasseSalariale(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete salary mass function by id
   * @param {MasseSalarialeResourceV2ApiDeleteMasseSalarialeFonctionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteMasseSalarialeFonction(
    requestParameters: MasseSalarialeResourceV2ApiDeleteMasseSalarialeFonctionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MasseSalarialeResourceV2ApiFp(this.configuration)
      .deleteMasseSalarialeFonction(requestParameters.id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get salary mass
   * @param {MasseSalarialeResourceV2ApiGetMasseSalarialeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getMasseSalariale(
    requestParameters: MasseSalarialeResourceV2ApiGetMasseSalarialeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MasseSalarialeResourceV2ApiFp(this.configuration)
      .getMasseSalariale(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create or update salary mass function by noteId and id
   * @param {MasseSalarialeResourceV2ApiSaveMasseSalarialeFonctionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saveMasseSalarialeFonction(
    requestParameters: MasseSalarialeResourceV2ApiSaveMasseSalarialeFonctionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MasseSalarialeResourceV2ApiFp(this.configuration)
      .saveMasseSalarialeFonction(
        requestParameters.noteId,
        requestParameters.masseSalarialeFonctionInput,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create or update salary mass
   * @param {MasseSalarialeResourceV2ApiUpdateMasseSalarialeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateMasseSalariale(
    requestParameters: MasseSalarialeResourceV2ApiUpdateMasseSalarialeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MasseSalarialeResourceV2ApiFp(this.configuration)
      .updateMasseSalariale(requestParameters.saveMasseSalarialeRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
